/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilitySeats
 */
export interface FacilitySeats {
    /**
     * 
     */
    rooms?: number;
    /**
     * 
     */
    residents?: number;
}

/**
 * Check if a given object implements the FacilitySeats interface.
 */
export function instanceOfFacilitySeats(value: object): value is FacilitySeats {
    return true;
}

export function FacilitySeatsFromJSON(json: any): FacilitySeats {
    return FacilitySeatsFromJSONTyped(json, false);
}

export function FacilitySeatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilitySeats {
    if (json == null) {
        return json;
    }
    return {
        
        'rooms': json['rooms'] == null ? undefined : json['rooms'],
        'residents': json['residents'] == null ? undefined : json['residents'],
    };
}

export function FacilitySeatsToJSON(json: any): FacilitySeats {
    return FacilitySeatsToJSONTyped(json, false);
}

export function FacilitySeatsToJSONTyped(value?: FacilitySeats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rooms': value['rooms'],
        'residents': value['residents'],
    };
}

